import Router from 'vue-router';
import routes from './routes';
import store from '@/store';
import Vue from 'vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    /**
     * @override
     */
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    store.dispatch('loaderStore/isVisible', true);
    next();
});

router.beforeResolve((to, from, next) => {
    next();
});

export default router;
